import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import styles from "./ShipFromStoreDrawer.module.scss";
import { TickOutlined as Tick } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TickOutlined";
import { InfoOutlined as Info } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/InfoOutlined";
import { CloseOutlined as Close } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import { useRef } from "react";
import { dispatchAnalyticsEvent } from "@/utils";

interface Props {
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
  isStandardDelivery: boolean;
}

export function ShipFromStoreDrawer({
  isDrawerOpen,
  setIsDrawerOpen,
  isStandardDelivery,
}: Props) {
  const isDrawerInteractionDispatched = useRef(false);

  function dispatchOverlayClosedEvent() {
    dispatchAnalyticsEvent("shipfromstore.overlayClosed", {}, {});
  }

  const handleClose = () => {
    setIsDrawerOpen(false);
    if (!isDrawerInteractionDispatched.current) {
      dispatchOverlayClosedEvent();
      isDrawerInteractionDispatched.current = true;
    }
  };
  return (
    <Drawer
      isOpen={isDrawerOpen}
      onClose={handleClose}
      heading="Delivery from store"
      className={styles.express}
    >
      <Message
        body="This item is out of stock online, but it can be delivered to you directly from one of our stores."
        type="information"
        className={styles.express__message}
      />
      <p className={styles.express__text}>
        You can only buy this item using express checkout. Any other items in
        your basket will be saved there for you to buy later.
      </p>
      {isStandardDelivery ? (
        <span className={styles.express__item}>
          <Tick size="medium" />
          Standard delivery costs £4.50 and is within 2 to 5 days, Monday to
          Saturday.
        </span>
      ) : (
        <span className={styles.express__item}>
          <Tick size="medium" />
          Free standard delivery within 2 to 5 days, Monday to Saturday.
        </span>
      )}
      <span className={styles.express__item}>
        <Close size="medium" />
        Click &amp; Collect is not available for this item.
      </span>
      <span className={styles.express__item}>
        <Info size="medium" />
        Special offers and promotions may not be available.
      </span>
      <p className={styles.express__text}>
        This is a trial service. We&apos;ll keep you updated on the progress of
        your order by email.
      </p>
    </Drawer>
  );
}
